import { ESG_GERL_QUIZ_COMMENT_TEMPLATE } from '#data/esg-gerl-quiz-comment';
import type { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

export const repRiskInReviewMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        iterationId: 'iterationId',
        lineOfBusiness: LineOfBusiness.TCI,
        companyId: '113',
        statusCode: IterationStatusCode.CREATED,
        creation: {
          creationDateTime: '2024-04-19T10:05:42.156Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        controls: [
          {
            controlCode: 'ReputationalRisk',
            statusCode: ControllerStatus.ESCALATING,
            check: {
              requestorId: 'CVE',
              requestDateTime: '2024-05-21T13:29:56.409Z',
              responseDateTime: '2024-05-21T16:29:56.409Z',
              expirationDateTime: '2025-05-21T13:29:56.409Z',
              controlData: {},
            },
            escalation: {
              requestDateTime: '2020-10-10T00:00:00.000Z',
              requestorId: 'CVE',
              controlData: {
                internalTicketId: '1234',
              },
              requestDocumentIds: ['62b947463-c434-47f5-a714-3e74e233a886'],
            },
          },
        ],
        customProperties: {
          esgGerlQuizComment: ESG_GERL_QUIZ_COMMENT_TEMPLATE,
        },
      } satisfies VettingIteration,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/ReputationalRisk$',
    },
    response: {
      status: 200,
      body: {
        controlCode: 'ReputationalRisk',
        statusCode: ControllerStatus.ESCALATING,
        check: {
          requestorId: 'CVE',
          requestDateTime: '2024-05-21T13:29:56.409Z',
          responseDateTime: '2024-05-21T16:29:56.409Z',
          expirationDateTime: '2025-05-21T13:29:56.409Z',
          controlData: {},
        },
        escalation: {
          requestDateTime: '2020-10-10T00:00:00.000Z',
          requestorId: 'CVE',
          controlData: {
            internalTicketId: '1234',
          },
          requestDocumentIds: ['62b947463-c434-47f5-a714-3e74e233a886'],
        },
      } satisfies ControllerDetails,
    },
  },
];
